export default class DotenvConfig {
  static USERNAME = process.env.REACT_APP_USERNAME;
  static PASSWORD = process.env.REACT_APP_PASSWORD;
}
